import {writable, get} from "svelte/store";
import {resumen, resumenDeGrupo} from '../Api/trabajadores';

const estadoInicial = {
  cargando: false,
  error: null,
  listado: []
};

const store = writable(estadoInicial);

export default {
  subscribe: store.subscribe,
  cargar: () => {
    const timeout = setTimeout(() => store.update(valor => ({...valor, cargando: true})), 100);

    store.update(() => estadoInicial);

    resumen()
        .then(listado => store.update(valor => ({
          ...valor,
          listado: listado,
          error: false
        })))
        .catch(e => store.update(valor => ({...valor, error: e})))
        .finally(() => {
          clearTimeout(timeout);
          store.update(valor => ({...valor, cargando: false}));
        });
  },
  cargarDeGrupo: grupo => {
    const timeout = setTimeout(() => store.update(valor => ({...valor, cargando: true})), 100);

    store.update(() => estadoInicial);

    resumenDeGrupo(grupo)
        .then(listado => store.update(valor => ({
          ...valor,
          listado: listado,
          error: false
        })))
        .catch(e => store.update(valor => ({...valor, error: e})))
        .finally(() => {
          clearTimeout(timeout);
          store.update(valor => ({...valor, cargando: false}));
        });
  },
};